import { Button, ColorPicker, Input, Modal } from "antd";
import React, { useState } from "react";
import { svg } from "../../../../../Assets/svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ColorFormatType } from "antd/es/color-picker/interface";
import { useAppDispatch } from "../../../../../store";
import { createProductTagAPI, updateProductTagAPI } from "../../productTagApis";

interface Props {
  open: boolean;
  onClose: () => void;
  refreshData: () => void;
  editData?: any | null;
}

const getHexColor = (color: any) => {
  if (!color) return "";

  // If already a string (hex), return as is
  if (typeof color === "string") return color;

  // If it's a color object, convert it
  if (color.toHexString) return color.toHexString();

  return "";
};

const CreateProductTagModal = ({
  open,
  onClose,
  refreshData,
  editData,
}: Props) => {
  const dispatch = useAppDispatch();

  const [saving, setSaving] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      color: editData?.color ?? "#000000",
      name: editData?.name ?? null,
      format: "hex" as ColorFormatType,
    },
    onSubmit: (values) => {
      const payload = {
        ...(editData?._id && { id: editData?._id }),
        name: values?.name,
        color: getHexColor(values?.color),
        format: "hex",
      };
      setSaving(true);
      if (editData?._id) {
        dispatch(
          updateProductTagAPI({
            payload,
            onSuccess: () => {
              setSaving(false);
              refreshData();
              onClose();
            },
            onError: () => {
              setSaving(false);
            },
          }),
        );
      } else {
        dispatch(
          createProductTagAPI({
            payload,
            onSuccess: () => {
              setSaving(false);
              refreshData();
              onClose();
            },
            onError: () => {
              setSaving(false);
            },
          }),
        );
      }
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      // color: Yup.mixed().required("Color is required"),
    }),
  });
  return (
    <Modal
      open={open}
      centered
      width={"33.75rem"}
      footer={null}
      onCancel={onClose}
      closeIcon={svg?.closeIcon}
      maskClosable={false}
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          {editData ? "Update Product Tag" : "Create Product Tag"}
        </div>
      }
      className="commonModalClass"
    >
      <form
        className="page-form d-flex flex-column gap-3"
        onSubmit={formik.handleSubmit}
      >
        <div className="d-flex flex-column gap-3">
          <div>
            <label className="custom-label mb-1 ff">Color</label>
            <ColorPicker
              format={formik?.values?.format}
              className="department-color-picker w-100"
              value={formik?.values?.color}
              onChange={(color) => {
                formik?.setFieldValue("color", color);
              }}
              onFormatChange={(format) => {
                formik?.setFieldValue("format", format);
              }}
            />
            {formik.errors.color && formik.touched.color && (
              <span className="text-danger">
                {formik.errors.color as React.ReactNode}
              </span>
            )}
          </div>
          <div className="custom-placeholder-parent">
            <label className="custom-label mb-1 ff">Name</label>
            <Input
              name="name"
              placeholder="Enter Name"
              autoComplete="off"
              style={{
                backgroundColor: getHexColor(formik?.values?.color),
              }}
              value={formik?.values?.name}
              onChange={(e) => formik.setFieldValue("name", e.target.value)}
              className="form-control form-control-lg text-white"
            />
            {formik.errors.name && formik.touched.name && (
              <span className="text-danger">
                {formik.errors.name as React.ReactNode}
              </span>
            )}
          </div>
          <div className="d-flex justify-content-center gap-3 mt-4">
            <Button
              onClick={onClose}
              disabled={saving}
              className="btn btn-lg btn-outline-secondary h-auto px-5"
            >
              CLOSE
            </Button>

            <Button
              // onClick={() => formik.handleSubmit()}
              loading={saving}
              htmlType="submit"
              className="btn btn-lg btn-primary h-auto px-5"
            >
              {editData ? "UPDATE" : "SAVE"}
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default CreateProductTagModal;
